export const focusVisibleStyles = {
  boxShadow: 'none',
  outline: '2px solid',
  outlineOffset: '2px',
  outlineColor: '#7AF182',
}
